import { NestedTreeControl } from '@angular/cdk/tree';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone, ViewEncapsulation } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Router } from '@angular/router';
import { hasLength } from '@mtna/core-ts';

import { RdsNavTreeItem } from './nav-tree-item.model';

/**
 * Navigational tree component.
 *
 * Uses mat-tree component to display items their children. Uses NavTreeItem
 */
@Component({
  selector: 'rds-c-nav-tree',
  templateUrl: './nav-tree.component.html',
  styleUrls: ['./nav-tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RdsNavTreeComponent {
  static ngAcceptInputType_items: RdsNavTreeItem[] | null | undefined;

  @Input()
  get items(): Array<RdsNavTreeItem> {
    return this._items;
  }
  set items(items: Array<RdsNavTreeItem>) {
    this._items = items || [];

    this.dataSource.data = [...this.items];
    this.triggerExpansionCheck();
  }
  private _items: Array<RdsNavTreeItem> = [];

  dataSource: MatTreeNestedDataSource<RdsNavTreeItem> = new MatTreeNestedDataSource<RdsNavTreeItem>();
  treeControl: NestedTreeControl<RdsNavTreeItem> = new NestedTreeControl<RdsNavTreeItem>((node) => node.children);

  constructor(private cdr: ChangeDetectorRef, private router: Router, private zone: NgZone) {}

  hasChild(_: number, node: RdsNavTreeItem) {
    return !!node.children?.length;
  }

  /**
   * Toggles expansion of any tree nodes with an active child node
   */
  triggerExpansionCheck() {
    this.zone.runOutsideAngular(() => {
      this.dataSource.data
        .filter((i) => hasLength(i.children || []))
        .forEach((item) => {
          if (this._checkAndExpandItemChildren(item)) {
            this.treeControl.expand(item);
            this._updateChangeDetection();
          }
        });
    });
  }

  /**
   * Determines whether an item has an active child & should be expanded
   * @param item tree item to check whether it should be expanded
   * @returns whether the item has an active child
   */
  private _checkAndExpandItemChildren(item: RdsNavTreeItem): boolean {
    let expand = false;
    if (this.router.url?.includes(item.url)) {
      expand = true;
    }

    return (
      item.children?.some((i) => {
        if (this._checkAndExpandItemChildren(i)) {
          this.treeControl.expand(i);
          return true;
        }
        return false;
      }) || expand
    );
  }

  private _updateChangeDetection() {
    this.zone.run(() => this.cdr.markForCheck());
  }
}
